var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"button",on:{"click":_vm.tiaozhuan}},[_vm._v("跳转")])])}
var staticRenderFns = []

export { render, staticRenderFns }